import { useEffect, useState } from 'react';
import { QueryClientProvider, QueryClient } from 'react-query';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import queryString from 'query-string';
import { auth, onAuthStateChanged } from 'api/services/firebase';
import { ModalContextProvider } from 'components/system/ModalContext';
import 'styles/globalStyles.scss';
import AppRoutes from './AppRoutes';

const queryClient = new QueryClient();

const App = ({ isMobile }) => {
  const [isAppLoaded, setIsAppLoaded] = useState(false);
  console.log('Is Mobile: ', isMobile);
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setIsAppLoaded(true);
      console.log('Auth state changed');
    });
    return unsub;
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ModalContextProvider>
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: queryString.parse,
            objectToSearchString: queryString.stringify,
          }}
        >
          <AppRoutes isAppLoaded={isAppLoaded} isMobile={isMobile} />
        </QueryParamProvider>
      </ModalContextProvider>
    </QueryClientProvider>
  );
};

export default App;
